/* THIS IS A BIT-AUTO-GENERATED FILE. DO NOT EDIT THIS FILE DIRECTLY. */

<script>
module.exports = require('./IndeedTagLanding.vue')
</script>
